import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { texts } from "../../../../../general/texts";

const DynamicTaxSelector = ({
  classes,
  utilitySliceState,
  state,
  textFields,
  handleAddTextField,
  handleChange,
  setTextFields,
  handleRemoveTextField,
  handleStartTransaction,
  handleTextFieldChange,
}) => {
  return (
    <Grid container item md={12} xs={12}>
      <Grid item md={12} xs={12} mb={3}>
        <Button onClick={handleAddTextField} className={classes.addTaxesButton}>
        {texts["button-add-local-obligations"]}
        </Button>
      </Grid>
      {textFields.map((value, index) => (
        <Grid container item md={12} key={index} rowGap={2} mt={2}>
          <Grid container item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>
            {texts["local-obligations"]}
            </Typography>
          </Grid>
          <Box className={classes.textField}>
            <FormControl fullWidth size="small" color="warning">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={textFields[index].selectedOption}
                onChange={(event) => handleChange(index, event)}
                MenuProps={{ sx: { height: "700px" } }}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    // Autofocus on textfield
                    autoFocus
                    color={"warning"}
                    label="Kërko taksën"
                    fullWidth
                    onChange={handleTextFieldChange("search")}
                    value={state.search}
                    onKeyDown={(e) => {
                      if (e.key !== "Escape") {
                        // Prevents autoselecting item while typing (default Select behaviour)
                        e.stopPropagation();
                      }
                    }}
                  />
                </ListSubheader>
                {utilitySliceState.listOfTaxes && utilitySliceState.listOfTaxes
                  .filter(
                    (listOfTaxes) =>
                      listOfTaxes.emertimi
                        .toLowerCase()
                        .includes(state.search.toLowerCase()) ||
                      listOfTaxes.kodiEkonomik
                        .toLowerCase()
                        .includes(state.search.toLowerCase())
                  )
                  .map((option, optionIndex) => (
                    <MenuItem key={optionIndex} value={optionIndex}>
                      {option.kodiEkonomik + " - "}
                      {option.emertimi}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <Grid container item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>Vlera</Typography>
          </Grid>
          <TextField
            value={value.value}
            size="small"
            color="warning"
            fullWidth={true}
            onChange={(event) => {
              const { value } = event.target;
              const newFields = [...textFields];
              newFields[index].value = value;
              setTextFields(newFields);
            }}
          />
          <Grid item md={12} xs={12} mt={1}>
            <Button
              onClick={() => handleRemoveTextField(index)}
              className={classes.removeTaxesButton}
            >
              Hiq
            </Button>
          </Grid>
        </Grid>
      ))}
      <Grid item md={12} xs={12} mt={1}>
        <Button
          disabled={
            textFields.length === 0 ||
            textFields.some(
              (field) =>
                field.emertimi === "" ||
                field.kodiEkonomik === "" ||
                field.value === ""
            )
          }
          onClick={() => handleStartTransaction("singleInvoice")}
          className={classes.button}
        >
          {texts["button-continue"]}
        </Button>
      </Grid>
    </Grid>
  );
};

export default DynamicTaxSelector;

// {textFields.map((value, index) => (
//   <Grid container item md={12} key={index} rowGap={2} mt={2}>
//     <TextField
//       select
//       label="Detyrime vendore"
//       value={textFields[index].selectedOption}
//       onChange={(event) => handleChange(index, event)}
//       color="warning"
//       size="small"
//       fullWidth={true}
//     >
//       {utilitySliceState.listOfTaxes.map((option, optionIndex) => (
//         <MenuItem key={optionIndex} value={optionIndex}>
//           {option.kodiEkonomik + " - "}{option.emertimi}
//         </MenuItem>
//       ))}
//     </TextField>
//     <Grid container item md={12} xs={12}>
//       <Typography
//         sx={{
//           color: colors.darkBlue,
//           fontSize: "1.2rem",
//           fontFamily: "GerberaBold",
//           textAlign: "left",
//         }}
//       >
//         Vlera
//       </Typography>
//     </Grid>
//     <TextField
//       value={value.value}
//       size="small"
//       color="warning"
//       fullWidth={true}
//       onChange={(event) => {
//         const { value } = event.target;
//         const newFields = [...textFields];
//         newFields[index].value = value;
//         setTextFields(newFields);
//       }}
//     />
//     <Grid item md={12} xs={12} mt={1}>
//       <Button
//         onClick={() => handleRemoveTextField(index)}
//         className={classes.removeTaxesButton}
//       >
//         Hiq
//       </Button>
//     </Grid>
//   </Grid>
// ))}
